import React from "react";
import AppBar from 'material-ui/AppBar';

const AvailabilityHeadingHotel = ({property}) => {
  return (
      <AppBar title={property.name}  iconElementLeft={<div/>} style={styles.customStyle} className="availabilityHeading"/>
  )
};

const styles = {
  customStyle: {
    fontFamily: 'inherit'
  },
};

export default AvailabilityHeadingHotel;


// WEBPACK FOOTER //
// ./src/components/AvailabilityHeadingHotel.js